import { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useSportsAuth } from '../SportsAuthContext';
import { AuthShell, SportsInput, SportsButton } from '../components/AuthShell';

function errText(detail) {
  if (!detail) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return detail?.msg || String(detail);
}

export default function SportsLoginPage() {
  const { login, user, loading } = useSportsAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  // Already logged in → go to dashboard
  if (!loading && user) {
    return <Navigate to="/sports/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate('/sports/dashboard');
    } catch (err) {
      toast.error(errText(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Owner Sign In"
      subtitle="Manage your courts, bookings and customer site."
      footer={
        <span>
          New here?{' '}
          <Link to="/sports/register" className="text-[#E63946] font-semibold" data-testid="sports-go-register-link">
            Create an account
          </Link>
        </span>
      }
    >
      <form onSubmit={submit}>
        <SportsInput label="Email" type="email" testid="sports-login-email" value={email}
          onChange={(e) => setEmail(e.target.value)} required placeholder="you@court.com" />
        <SportsInput label="Password" type="password" testid="sports-login-password" value={password}
          onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
        <div className="flex justify-end -mt-2 mb-5">
          <Link to="/sports/forgot-password" className="text-xs text-[#A3A3A3] hover:text-white" data-testid="sports-forgot-link">
            Forgot password?
          </Link>
        </div>
        <SportsButton type="submit" testid="sports-login-submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign In'}
        </SportsButton>
      </form>
    </AuthShell>
  );
}
